import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CellType } from '../../types/Common';
import { TJobOffer } from '../../types/JobOffer';
import { getJobApplication } from '../../apis/job';
import CustomTable from '../../components/UI/CustomTable';
import CustomPagination from '../../components/UI/CustomPagination';
import { getBgColorBadgeJobStatus, translateJobStatus } from '../../constants/job';
import SubmitDialog from '../../components/JobApplication/SubmitDialog';
import CustomButton from '../../components/UI/CustomButton';
import useStyle from './useStyles';

const JobApplication = () => {
  const classes = useStyle();
  const [openSubmitDialog, setOpenSubmitDialog] = useState(false);
  const [selectJobApplication, setSelectJobApplication] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [jobApplicationList, setJobApplicationList] = useState<TJobOffer[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getJobApplicationData = () => {
    setLoading(true);
    getJobApplication(currentPage, rowsPerPage)
      .then((res: any) => {
        setJobApplicationList(res.applications || []);
        setTotalPages(res.pagination?.totalPages || 1);
      })
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getJobApplicationData();
  }, [currentPage, rowsPerPage]);

  const JobApplicationStatus = (row: any) => {
    const { status } = row || {};

    return (
      <Box className={classes.badgeContainer}>
        <Box className={classes.badge} bgcolor={getBgColorBadgeJobStatus(status)}>
          {translateJobStatus(status)}
        </Box>
      </Box>
    );
  };

  const JobApplicationAction = (row: any) => {
    return (
      <CustomButton
        variant='text'
        size='small'
        fullWidth
        onClick={() => {
          setSelectJobApplication(row);
          setOpenSubmitDialog(true);
        }}
      >
        <Typography color='text.main'>جزئیات</Typography>
      </CustomButton>
    );
  };

  const tableHead = [
    {
      key: 'row',
      label: 'ردیف',
      type: CellType.ROW,
    },
    {
      key: 'userName',
      label: 'نام',
      type: CellType.STRING,
    },
    {
      key: 'jobTitle',
      label: 'عنوان',
      type: CellType.STRING,
    },
    {
      key: 'applicationDate',
      label: 'تاریخ ایجاد',
      type: CellType.DATE,
    },
    {
      key: 'status',
      label: 'وضعیت درخواست',
      type: CellType.ACTION,
      action: JobApplicationStatus,
    },
    {
      key: 'action',
      label: '',
      type: CellType.ACTION,
      action: JobApplicationAction,
    },
  ];

  return (
    <Box className={classes.mainContainer}>
      <CustomTable
        rows={jobApplicationList}
        tableHead={tableHead}
        loading={loading}
        rowsIndex={rowsPerPage * (currentPage - 1)}
      />

      <CustomPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChangeCurrentPage={(page: number) => setCurrentPage(page)}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={(rowsPerPage: number) => {
          if (currentPage !== 0) setCurrentPage(1);
          setRowsPerPage(rowsPerPage);
        }}
      />

      <SubmitDialog
        openSubmitDialog={openSubmitDialog}
        closeDialog={() => setOpenSubmitDialog(false)}
        selectJobApplication={selectJobApplication}
        getJobApplicationData={getJobApplicationData}
      />
    </Box>
  );
};

export default JobApplication;
